var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10279",
    "data-name": "Path 10279",
    d: "M40,0a40,40,0,0,1,0,80H38.46L40,40,.128,42.1S0,40.91,0,40A40,40,0,0,1,40,0Z",
    fill: "#2c53bb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loader",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_15836",
    "data-name": "Path 15836",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40 10 C 23.45793914794922 10 10 23.45793914794922 10 40 C 10 56.54206085205078 23.45793914794922 70 40 70 C 56.54206085205078 70 70 56.54206085205078 70 40 C 70 23.45793914794922 56.54206085205078 10 40 10 M 40 0 C 62.09140014648438 0 80 17.90859985351562 80 40 C 80 62.09140014648438 62.09140014648438 80 40 80 C 17.90859985351562 80 0 62.09140014648438 0 40 C 0 17.90859985351562 17.90859985351562 0 40 0 Z",
    stroke: "none",
    fill: "#2c53bb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.bca9e9c703f61b94a84292f9ce2f38f2.svg";
export { ForwardRef as ReactComponent };